import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import getCommonProps from "../../primitives/ButtonPrimitive/common/getCommonProps";

const getButtonLinkCommonProps = props => {
  if (!props.compact) return getCommonProps(props);
  return _objectSpread(_objectSpread({}, getCommonProps(props)), {}, {
    padding: "0"
  });
};

export default getButtonLinkCommonProps;